import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  Snackbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Container,
  AppBar,
  Toolbar,
  Grid,
  TableContainer,
  Button,
  TextField,
  CircularProgress,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import axios from "axios";
import envConfig from "../../bin/env.config";
import { useSelector } from "react-redux";
import { SaveAlt as SaveAltIcon } from '@material-ui/icons';
import { STATUS_OPTIONS, STATUS_COLORS, BACKGROUND_STATUS_COLORS, STATUS_ICONS, formatOodEditedBy } from '../../utility/statusConfig';
import CitySelector from './CustomerReport/CitySelector';
import BannerSelector from './CustomerReport/BannerSelector';
import ButtonCompanyProductNote from './Products/ButtonCompanyProductNote';
export default function CompanyReportToolCheckedReportPage(props) {
  const token = useSelector((state) => state.session.token);
  const user_type_id = props.match.params.user_type_id;
  const project_id = props.match.params.project_id;
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedBanners, setSelectedBanners] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(1);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const handleCitySelect = (city) => {
    setSelectedCity(city);
  };

  const handleBannerSelect = (banner) => {
    setSelectedBanners(prev => {
      if (banner === '') {
        return []; 
      }
      if (prev.includes(banner)) {
        return prev.filter(b => b !== banner); 
      }
      return [...prev, banner]; 
    });
  };
  
  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleStatusClose = () => {
    setStatusAnchorEl(null);
  };

  const handleStatusSelect = (status) => {
    setSelectedStatus(status);
    handleStatusClose();
  };
  
  const fetchCheckedProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/not-updated-check-report`,
        {
          user_type_id: user_type_id,
          project_id: project_id,
          city: selectedCity,
          banners: selectedBanners,
          status_id: selectedStatus
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setCheckedProducts(response.data.data || []);
    } catch (error) {
      console.error("Error fetching checked products:", error);
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  
  useEffect(() => {
    fetchCheckedProducts();
  }, [selectedCity, selectedBanners, selectedStatus]);

  const handleErrorClose = () => {
    setShowError(false);
  };

  // Filter products based on product name, store name, or city
  const filteredProducts = checkedProducts.filter(product => {
    if (!filterText) return true;
    const lowerFilter = filterText.toLowerCase();
    return (
      (product.fullname || '').toLowerCase().includes(lowerFilter) ||
      (product.store_name || '').toLowerCase().includes(lowerFilter) ||
      (product.store_address || '').toLowerCase().includes(lowerFilter) ||
      (product.store_postal || '').toLowerCase().includes(lowerFilter) ||
      (product.city || '').toLowerCase().includes(lowerFilter)
    );
  });
 
  // Export to CSV
  const handleExportCSV = () => {
    const headers = [
      'Company Product ID',
      'Store ID',
      'Store Name',
      'Store Address',
      'Store Postal',
      'City',
      'Product ID',
      'PMG ID',
      'Product Name',
      'Size',
      'Company ID',
      'Company Name',
      'Status',
      'Price',
      'Note',
      'Last Collected',
      'Product Link'
    ];

    let csv = headers.join(',');
    csv += '\n';
    filteredProducts.forEach(product => {
      const rowData = [
        product.company_product_id,
        product.store_id,
        `"${(product.store_name || '').replace(/"/g, '""')}"`,
        `"${(product.store_address || '').replace(/"/g, '""')}"`,
        `"${(product.store_postal || '').replace(/"/g, '""')}"`,
        `"${(product.city || '').replace(/"/g, '""')}"`,
        product.product_id,
        product.product_matching_group_id,
        `"${(product.fullname || '').replace(/"/g, '""')}"`,
        product.size,
        product.company_id,
        `"${(product.company_name || '').replace(/"/g, '""')}"`,
        product.status_id,
        product.price,
        `"${(product.note || '').replace(/"/g, '""')}"`,
        product.last_collected_date ? new Date(product.last_collected_date).toLocaleDateString() : '',
        `"${(product.external_link || '').replace(/"/g, '""')}"`
      ];
      csv += rowData.join(',') + '\n';
    });

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'checked_store_products.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleExportJSON = () => {
    const items = filteredProducts.map(product => ({
      company_product_id: product.company_product_id,
      store_id: product.store_id,
      product_matching_group_id: product.product_matching_group_id,
      company_name: product.company_name || '',
      store_postal: product.store_postal || '',
      external_link: product.external_link || '',
    }));

    const json = JSON.stringify(items, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'checked_store_products.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <AppBar position="sticky" color="inherit">
        <Toolbar>
          <Typography variant="h6" noWrap style={{ marginRight: '20px' }}>
            Checked Report by Store
          </Typography>
          <CitySelector
            selectedCity={selectedCity}
            onCitySelect={handleCitySelect}
            project_id={project_id}
            token={token}
          />
          <BannerSelector
            project_id={project_id}
            token={token}
            selectedBanners={selectedBanners}
            onBannerSelect={handleBannerSelect}
          />
          
          <Button
            variant="outlined"
            onClick={handleStatusClick}
            style={{ minWidth: 200, justifyContent: 'flex-start', marginRight: '16px', color: STATUS_COLORS[selectedStatus], backgroundColor: BACKGROUND_STATUS_COLORS[selectedStatus] }}
            endIcon={STATUS_ICONS[selectedStatus]}
          >
            {STATUS_OPTIONS[selectedStatus]} 
          </Button>
          <Menu
            anchorEl={statusAnchorEl}
            keepMounted
            open={Boolean(statusAnchorEl)}
            onClose={handleStatusClose}
          >
            {Object.keys(STATUS_OPTIONS).map((key) => (
              <MenuItem key={key} onClick={() => handleStatusSelect(key)} 
              style={{ color: STATUS_COLORS[key], backgroundColor: BACKGROUND_STATUS_COLORS[key] }}
              >
                <ListItemIcon style={{ color: STATUS_COLORS[key] }}>
                  {STATUS_ICONS[key]}
                </ListItemIcon>
                <ListItemText>{STATUS_OPTIONS[key]} </ListItemText>
              </MenuItem>
            ))}
          </Menu>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Filter by product or store"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            style={{ minWidth: 200 }}
          />
          <Box display="flex" style={{ marginLeft: 'auto' }}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<SaveAltIcon />}
              onClick={handleExportJSON}
              style={{ marginRight: 8 }}
            >
              Export JSON
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<SaveAltIcon />}
              onClick={handleExportCSV}
            >
              Export CSV
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {loading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer style={{ maxHeight: 'calc(100vh - 122px)', width: '100%' }}>
              {filteredProducts.length > 0 ? (
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell title='company_product_id'>CP_id</TableCell>
                      <TableCell title='product_id'>P_id</TableCell>
                      <TableCell title='product_matching_group_id'>PMG_id</TableCell>
                      <TableCell title='store_id'>Store ID</TableCell>
                      <TableCell title='store_name'>Store</TableCell>
                      <TableCell title='store_address'>Address</TableCell>
                      <TableCell title='store_postal'>Postal</TableCell>
                      <TableCell title='city'>City</TableCell>
                      <TableCell title='fullname'>Name</TableCell>
                      <TableCell title='company_name'>Company</TableCell>
                      <TableCell title='last_collected_date'>Last Collected</TableCell>
                      <TableCell title='price'>Checked Price</TableCell>
                      <TableCell title='note'>Note</TableCell>
                      <TableCell title='edited_at'>Edited At</TableCell>
                      <TableCell title='edited_by'>Edited By</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredProducts.map((product, index) => (
                      <TableRow key={index}>
                        <TableCell>{product.company_product_id} <ButtonCompanyProductNote company_product_id={product.company_product_id} /></TableCell>
                        <TableCell>{product.product_id}</TableCell>
                        <TableCell>
                            <Typography style={{ backgroundColor: '#f5f5f5',  width:'100px', cursor: 'pointer' }}
                         onClick={() => window.open(`/matching-group/${product.product_matching_group_id}`, '_blank')}
                        >{product.product_matching_group_id}</Typography>
                        </TableCell>
                        <TableCell>{product.store_id}</TableCell>
                        <TableCell>{product.store_name}</TableCell>
                        <TableCell>{product.store_address}</TableCell>
                        <TableCell>{product.store_postal}</TableCell>
                        <TableCell>{product.city}</TableCell>
                        <TableCell><Typography style={{
                            cursor: 'pointer',
                            color: BACKGROUND_STATUS_COLORS[product.status_id]
                          }} onClick={() => window.open(`${product.external_link}`, '_blank')}>{product.fullname}</Typography></TableCell>
                        <TableCell>{product.company_name}</TableCell>
                        <TableCell>{product.last_collected_date ? new Date(product.last_collected_date).toLocaleDateString() : ''}</TableCell>
                        <TableCell>{product.price}</TableCell>
                        <TableCell>{product.note}</TableCell>
                        <TableCell>
                          {product.edited_at ? new Date(product.edited_at).toLocaleString() : ''}
                        </TableCell>
                        <TableCell>
                          {formatOodEditedBy(product.edited_by, { statusId: product.status_id })}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography style={{ padding: '16px' }}>No checked store products found.</Typography>
              )}
            </TableContainer>
          )}
        </Grid>
      </Grid>
      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={handleErrorClose}
        message="Error loading data. Please try again."
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </>
  );
} 